import type { ConfigurationRuleGroupDto, QuotationDto } from '@api/machines'

import type { Options } from '@common/utils'

export interface IFormData {
  customerId: string
  customerName: string
  quoteId: string
  quoteName: string
}

export interface AddToQuoteForm {
  anotherUser?: string
  customerContactId?: null | number
  deliveryAddressId?: null | number
  quotation: QuotationDto | null
  quoteId: string
  quoteName: string
}

export interface ICustomCustomersList {
  customerId: number
  customerName: string
}

export interface SectionsErrorsType {
  serviceContract: boolean
  transportOption: boolean
  warranty: boolean
}

export interface RulesToBeAppliedListType {
  choice: ConfigurationRuleGroupDto[]
  metadata: {
    machineId?: string
    option: Options
    optionId: number
  }
}

export enum WizardSteps {
  OPTIONS = 0,
  OVERVIEW = 2,
  SERVICES = 1
}
